<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <div v-if="data.item.nuevoM2">
      <div v-if="(data.item.idTipoSolicitud === 17 || data.item.idTipoSolicitud === 22) && data.item.opcionAceptada !== null ">
        <router-link
            :to="{
        name: 'metodosDePagoPTI',
        params: { idPti: data.item.idPti, idSolicitud: data.item.idSolicitudDiagnostico, replica: 0 },
      }"
            v-if="
        resource.idEstatusSolicitud === 1 || resource.idEstatusSolicitud === 2
      "
        >
          <p
              v-if="resource.idEstatusSolicitud === 1"
              @click="putCambiarEstatusSolicitud(data.item.idSolicitudDiagnostico)"
              class="letraColorAzulPrincipal letraEstiloNegrita"
          >
            {{ data["item"].nombrePaciente }}
          </p>

          <p class="letraColorAzulPrincipal letraEstiloNegrita" v-else>
            {{ data.item.nombrePaciente }}
          </p>
        </router-link>
        <router-link
            v-else
            :to="{ name: 'paciente', params: { id: data.item.idPaciente } }"
        >
          <p class="letraColorAzulPrincipal letraEstiloNegrita">
            {{ data["item"].nombrePaciente }}
          </p>
        </router-link>
      </div>
      <div v-else>
        <router-link
            :to="{
        name: 'presentacionPti',
        params: { idPti: data.item.idPti, idSolicitud: data.item.idSolicitudDiagnostico,idTicket: data.item.idSolicitud, idEtapa: data.item.idEtapa },
      }"
            v-if="
        resource.idEstatusSolicitud === 1 || resource.idEstatusSolicitud === 2
      "
        >
          <p
              v-if="resource.idEstatusSolicitud === 1"
              @click="putCambiarEstatusSolicitud(data.item.idSolicitudDiagnostico)"
              class="letraColorAzulPrincipal letraEstiloNegrita"
          >
            {{ data["item"].nombrePaciente }}
          </p>

          <p class="letraColorAzulPrincipal letraEstiloNegrita" v-else>
            {{ data.item.nombrePaciente }}
          </p>
        </router-link>
        <router-link
            v-else
            :to="{ name: 'paciente', params: { id: data.item.idPaciente } }"
        >
          <p class="letraColorAzulPrincipal letraEstiloNegrita">
            {{ data["item"].nombrePaciente }}
          </p>
        </router-link>
      </div>

    </div>
    <div v-else>
      <router-link
          :to="{
        name: 'nuevopti',
        params: { idPti: data.item.idPti, idSolicitud: data.item.idSolicitudDiagnostico },
      }"
          v-if="
        resource.idEstatusSolicitud === 1 || resource.idEstatusSolicitud === 2
      "
      >
        <p
            v-if="resource.idEstatusSolicitud === 1"
            @click="putCambiarEstatusSolicitud(data.item.idSolicitudDiagnostico)"
            class="letraColorAzulPrincipal letraEstiloNegrita"
        >
          {{ data["item"].nombrePaciente }}
        </p>

        <p class="letraColorAzulPrincipal letraEstiloNegrita" v-else>
          {{ data.item.nombrePaciente }}
        </p>
      </router-link>
      <router-link
          v-else
          :to="{ name: 'paciente', params: { id: data.item.idPaciente } }"
      >
        <p class="letraColorAzulPrincipal letraEstiloNegrita">
          {{ data["item"].nombrePaciente }}
        </p>
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: "BandejaLinkPacienteComponente",
  props: {
    data: Object,
    resource: Object,
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
  }),
  created(){
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    putCambiarEstatusSolicitud(idSolicitudDiagnostico) {
      var params = {
        idSolicitudDiagnostico: idSolicitudDiagnostico,
        idUsuarioLogueado: this.$localStorageService.getIdUsuario(),
      };

      this.$http
        .put(
          this.$api + "pti/bandeja/embajador/cambiarEstatusSolicitud",
          params
        )
        .then((response) => {
          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>
